import { parseColorHexRGB } from "@microsoft/fast-colors";
import { SwatchRGB } from "../color/index.js";
import { PaletteRGB } from "../color/palette-rgb.js";
import { create, createNonCss } from "./create.js";
/** @public */
export const neutralBaseColor = create("neutral-base-color").withDefault("#808080");
/** @public */
export const neutralBaseSwatch = createNonCss("neutral-base-swatch").withDefault((element) => SwatchRGB.from(parseColorHexRGB(neutralBaseColor.getValueFor(element))));
/** @public */
export const neutralPalette = createNonCss("neutral-palette").withDefault((element) => PaletteRGB.from(neutralBaseSwatch.getValueFor(element)));
/** @public */
export const accentBaseColor = create("accent-base-color").withDefault("#0078D4");
/** @public */
export const accentBaseSwatch = createNonCss("accent-base-swatch").withDefault((element) => SwatchRGB.from(parseColorHexRGB(accentBaseColor.getValueFor(element))));
/** @public */
export const accentPalette = createNonCss("accent-palette").withDefault((element) => PaletteRGB.from(accentBaseSwatch.getValueFor(element)));
